import React, {useState} from 'react';
import {Card, Progress} from 'antd';
import Button from '@common/Button';
import Tooltip from '@common/Tooltip';
import {
    DeleteRounded,
    KeyboardArrowDownRounded,
    KeyboardArrowUpRounded
} from '@mui/icons-material';

const ReviewBlock = ({
    icon,
    label,
    alwaysIncluded = false,
    headerRight,
    headerActions,
    selectedCount,
    totalCount,
    children,
    moreOptionsContent,
    moreOptionsCount,
    onRemove,
}) => {
    const [expanded, setExpanded] = useState(false);

    return (
        <Card className="ch-lesson-planner-review-block" styles={{body: {padding: 0}}}>
            <div className="ch-lesson-planner-review-block-header">
                <div className="ch-lesson-planner-review-block-title">
                    <span aria-hidden="true">{icon}</span>
                    <strong>{label}</strong>
                </div>
                <div className="ch-lesson-planner-review-block-header-right">
                    {alwaysIncluded ? (
                        <span className="ch-lesson-planner-review-block-always-included">Always included</span>
                    ) : headerRight ? (
                        headerRight
                    ) : (
                        <div className="ch-lesson-planner-review-block-meta">
                            <span className="ch-lesson-planner-review-block-count">
                                {selectedCount} of {totalCount} selected
                            </span>
                            <Progress
                                percent={(selectedCount / totalCount) * 100}
                                showInfo={false}
                                size="small"
                                strokeColor="var(--primary-color, #1a7f5a)"
                                trailColor="var(--border-color, #d9d9d9)"
                                className="ch-lesson-planner-review-progress"
                            />
                            {headerActions && (
                                <div className="ch-lesson-planner-review-block-header-actions">
                                    {headerActions}
                                </div>
                            )}
                        </div>
                    )}
                    {onRemove && (
                        <Tooltip title="Remove section">
                            <Button
                                type="text"
                                className="ch-lesson-planner-review-block-remove"
                                onClick={onRemove}
                                aria-label={`Remove ${label} section`}
                                icon={<DeleteRounded />}
                            />
                        </Tooltip>
                    )}
                </div>
            </div>

            <div className="ch-lesson-planner-review-block-body">
                {children}
            </div>

            {moreOptionsContent && (
                <>
                    {expanded && (
                        <div className="ch-lesson-planner-review-block-more">
                            <span className="ch-lesson-planner-review-more-label">More options</span>
                            {moreOptionsContent}
                        </div>
                    )}
                    <button
                        type="button"
                        className="ch-lesson-planner-review-show-more"
                        onClick={() => setExpanded(e => !e)}
                        aria-expanded={expanded}
                    >
                        {expanded
                            ? <><KeyboardArrowUpRounded fontSize="small" /> Hide additional options</>
                            : <><KeyboardArrowDownRounded fontSize="small" /> Show {moreOptionsCount} additional option{moreOptionsCount !== 1 ? 's' : ''}</>
                        }
                    </button>
                </>
            )}
        </Card>
    );
};

export default ReviewBlock;
